export default "__VITE_ASSET__627fae39__"